import { Chain } from "@rainbow-me/rainbowkit";
import { arbitrum, mainnet, polygon } from "wagmi/chains";

export enum NetworkName {
  ETHEREUM = "Ethereum",
  POLYGON = "Polygon",
  ARBITRUM = "Arbitrum One",
}

export interface Network {
  chainId: number;
  name: NetworkName;
}

// Extract supported networks from wagmi
export const SUPPORTED_NETWORKS: Array<Chain> = [mainnet, arbitrum, polygon];
